import { useNavigate } from "react-router-dom";
// import useStoreAllCat from "../../store/catSUBCat/cat";
import { useEffect, useState } from "react";
import axios from "axios";
import Loader from "../../components/loader";
import { useTranslation } from "react-i18next";
import { URL } from "../../lib/apis";
import { scrollToTop } from "../../lib/utils";

const Categories = () => {
  const [loading, setLoading] = useState<boolean>(true)
  const navigate = useNavigate()
  const [categories, setCategories] = useState<any[]>([])
  const { t } = useTranslation()

  const updateCats = async () => {
    try {
      const { data } = await axios.get(
        `${URL}/categories/subcategories`,
        /*    {
             headers: {
               Authorization: `Bearer ${token}`, // Pass the token in headers
             },
           } */
      );
      setCategories(data.data)
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    scrollToTop()
  }, [])

  useEffect(() => {
    updateCats()
  }, [])
  console.log(categories)



  return (
    <div className="px-10 flex gap-10 justify-center flex-wrap mt-8">
      {loading ? <Loader /> :
        categories.map((item: any, index) => {
          return (
            <div
              key={index}
              className="w-full max-w-[450px] py-3 px-8"
              style={{ height: "200px", backgroundImage: `url(${item.category_image_url})`, backgroundRepeat: "no-repeat", backgroundSize: "cover" }}
            >
              <h3 className="text-black text-[26px] font-normal text-center mb-3">
                {t(`${item.category_name}`)}
              </h3>
              <div className="flex flex-wrap justify-center gap-5">
                {/* {item.SubCategories.map((product: any, index: number) => {
                  return (
                    <div key={index}>
                      <img
                        className="w-[183px] h-[134px]"
                        src={`${item.category_image_url}`}
                        alt=""
                      />
                      <h5 className="text-[16px] font-normal">{product.sub_category_name}</h5>
                    </div>
                  );
                })} */}
              </div>
              <div style={{ marginTop: "90px" }} className="flex justify-center min-[530px]:justify-end">
                <div onClick={() => {
                  navigate("/details_categories", { state: item })
                }} className="hover:underline cursor-pointer text-white">
                  {t("voir_tout")}
                </div>
                {/* <Link
                  className="hover:underline cursor-pointer text-white"
                  to={"/details_categories"}
                > */}
                {/* Voir tout */}
                {/* </Link> */}
              </div>
            </div>
          );
        })}
    </div>
  );
};
export default Categories;
